import { Playground, PLAYGROUNG_BG_LIGHTER } from '../../../components/playground/Playground';
import { PlaygroundClasses } from '../../../components/playground/PlaygroundClasses';
import { PlaygroundColors } from '../../../components/playground/PlaygroundColors';
import { Headline } from '../../../components/Headline';

import { colors, getColorNames } from '../../../utils/colors';

export const Callouts = () => (
    <div>
        <Headline anchor='callouts'>Callouts</Headline>
        <Playground
            example={callouts}
            classes={calloutsClasses}
            background={PLAYGROUNG_BG_LIGHTER}
            availableColors={<PlaygroundColors bgDefault bgPrimary bgSecondary bgInfo bgSuccess bgWarning bgDanger />}
        />
    </div>
);

const eachColor = ['default', ...getColorNames(colors.brand, colors.status)];
const eachVariant = ['condensed'];

const renderCalloutGrid = (condensed = false) => (
    <div className='display-grid grid-cols-1 grid-cols-2-ls grid-cols-3-md gap-20'>
        {eachColor.map((color, index) => (
            <div className={`callout callout-${color} ${condensed ? 'callout-condensed' : ''}`} key={index}>
                <div
                    className={`${
                        color !== 'default' ? `text-color-${color}` : ''
                    } text-medium ${condensed ? 'text-size-16' : 'text-size-20'} line-height-125rel`}
                >
                    Callout <span>{color}</span>
                </div>
                <p className={condensed ? 'margin-top-5' : ''}>
                    At vero eos et accusam et justo duo dolores et ea rebum clita kasd gubergren, no sea takimata.
                </p>
            </div>
        ))}
    </div>
);

const callouts = (
    <div>
        <h5 className='margin-top-0 margin-bottom-15'>Default callouts</h5>
        {renderCalloutGrid()}

        <h5 className='margin-top-25 margin-bottom-15'>Condensed callouts</h5>
        {renderCalloutGrid(true)}
    </div>
);

const calloutsClasses = (
    <>
        <PlaygroundClasses label='Colors' prefix='callout-' classes={eachColor} />
        <PlaygroundClasses label='Variants' prefix='callout-' classes={eachVariant} />
    </>
);
